import ILoanEmail from '~Api/LoanEmail/ILoanEmail';
import { IGlobalState } from '~reducer';
import { IDictionary } from '~utilities/IDictionary';
import { keyMap } from '~utilities/utils';

export function loanEmailSelector(state: IGlobalState, loanEmailUuid: string): ILoanEmail {
    return state.loanEmails.emails[loanEmailUuid];
}

export function loanEmailsPageSelector(state: IGlobalState, loanUuid: string): IDictionary<ILoanEmail> {
    if (!state.loanEmails.pageEmailUuids[loanUuid]) {
        return null;
    }

    return keyMap(state.loanEmails.pageEmailUuids[loanUuid], 'uuid', (loanEmailUuid: string): ILoanEmail => loanEmailSelector(state, loanEmailUuid));
}

export function loanEmailsPageNumberSelector(state: IGlobalState, loanUuid: string): number {
    return state.loanEmails.pageNumbers[loanUuid];
}

export function loanEmailsCountSelector(state: IGlobalState, loanUuid: string): number {
    return state.loanEmails.pageCounts[loanUuid];
}

export function loanEmailTextSelector(state: IGlobalState, loanEmailUuid: string): string {
    return state.loanEmails.texts[loanEmailUuid];
}
